(function () {
  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function post(path, body) {
    return fetch(routeRoot() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) { return response.json(); });
  }

  function init() {
    var root = document.querySelector('[data-vc]');
    if (!root || root.dataset.vcReady === 'true') return;
    root.dataset.vcReady = 'true';

    function reload() { window.location.reload(); }

    var depositId = Number(root.getAttribute('data-deposit')) || 0;
    var depositFor = root.getAttribute('data-deposit-for') || ',';

    // Waarborg altijd gelijk houden aan het aantal producten met waarborg.
    function depositCounts(cart) {
      var counts = { need: 0, have: 0 };
      (cart && cart.items ? cart.items : []).forEach(function (item) {
        if (item.variant_id === depositId) counts.have += item.quantity;
        else if (depositFor.indexOf(',' + item.product_id + ',') !== -1) counts.need += item.quantity;
      });
      return counts;
    }

    // Geeft true als de winkelmand daarna klopt en herladen zin heeft.
    function syncDeposit(cart) {
      if (!depositId) return Promise.resolve(true);
      var counts = depositCounts(cart);
      if (counts.need === counts.have) return Promise.resolve(true);
      var updates = {};
      updates[depositId] = counts.need;
      return post('cart/update.js', { updates: updates }).then(function (updated) {
        if (!updated || !updated.items) return false;
        var after = depositCounts(updated);
        return after.need === after.have;
      }, function () { return false; });
    }

    // Aantal wijzigen; weigert Shopify (bv. te weinig voorraad), dan melding tonen en aantal terugzetten.
    function lineError(key, message) {
      var box = root.querySelector('[data-vc-line-error="' + key + '"]');
      if (!box) return;
      box.textContent = message || '';
      box.hidden = !message;
    }

    function changeLine(key, quantity) {
      lineError(key, '');
      post('cart/change.js', { id: key, quantity: quantity })
        .then(function (result) {
          if (result && !result.items) {
            var wrap = root.querySelector('[data-vc-qty][data-key="' + key + '"]');
            var input = wrap && wrap.querySelector('input');
            if (input) input.value = input.defaultValue;
            lineError(key, result.description || result.message || 'Dit aantal kon niet aangepast worden.');
            return null;
          }
          return syncDeposit(result).then(reload, reload);
        })
        .catch(reload);
    }

    if (depositId && root.getAttribute('data-deposit-need') !== root.getAttribute('data-deposit-have')) {
      fetch(routeRoot() + 'cart.js')
        .then(function (response) { return response.json(); })
        .then(syncDeposit)
        .then(function (ok) { if (ok) reload(); })
        .catch(function () {});
    }

    root.querySelectorAll('[data-vc-qty]').forEach(function (wrap) {
      var key = wrap.getAttribute('data-key');
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (button) {
        button.addEventListener('click', function () {
          var delta = Number(button.getAttribute('data-delta'));
          var next = Math.max(0, (parseInt(input.value, 10) || 1) + delta);
          input.value = next;
          changeLine(key, next);
        });
      });
      input.addEventListener('change', function () {
        changeLine(key, Math.max(0, parseInt(input.value, 10) || 0));
      });
    });

    root.querySelectorAll('[data-vc-remove]').forEach(function (button) {
      button.addEventListener('click', function () {
        changeLine(button.getAttribute('data-key'), 0);
      });
    });

    function saveAttributes(attributes) {
      return post('cart/update.js', { attributes: attributes }).catch(function () {});
    }

    var switchButtons = root.querySelectorAll('[data-vc-method]');
    var pickupBlock = root.querySelector('[data-vc-pickup]');
    var shipBlock = root.querySelector('[data-vc-ship]');
    var methodField = root.querySelector('[data-vc-method-field]');

    function showMethod(method) {
      switchButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-vc-method') === method ? 'true' : 'false');
      });
      if (pickupBlock) {
        pickupBlock.hidden = method !== 'Afhalen';
        // Uitgeschakelde velden worden niet mee verstuurd bij het afrekenen
        pickupBlock.querySelectorAll('input[name^="attributes["]').forEach(function (field) {
          field.disabled = method !== 'Afhalen';
        });
      }
      if (shipBlock) shipBlock.hidden = method !== 'Verzenden';
      if (methodField) methodField.value = method;
      var shipLabel = root.querySelector('[data-vc-ship-label]');
      var shipValue = root.querySelector('[data-vc-ship-value]');
      if (shipLabel) shipLabel.textContent = method === 'Afhalen' ? 'Afhalen' : 'Verzending';
      if (shipValue) shipValue.textContent = method === 'Afhalen' ? 'Gratis' : 'Berekend bij afrekenen';
      if (typeof updateExpress === 'function') {
        showError('');
        updateExpress();
      }
    }

    switchButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var method = button.getAttribute('data-vc-method');
        showMethod(method);
        // Bij verzenden geen afhaalmoment op de bestelling; bij terugschakelen de keuze herstellen
        var pickup = method === 'Afhalen';
        saveAttributes({
          Levering: method,
          Afhaaldatum: pickup ? state.date : '',
          Afhaaluur: pickup ? state.slot : ''
        });
      });
    });

    var dateInput = root.querySelector('[data-vc-date]');
    var dateButton = root.querySelector('[data-vc-date-button]');
    var moment = root.querySelector('[data-vc-moment]');
    var slotButtons = Array.prototype.slice.call(root.querySelectorAll('[data-vc-slot]'));
    var slotValues = slotButtons.map(function (button) { return button.getAttribute('data-value'); });
    var state = {
      date: dateInput ? dateInput.value : '',
      label: root.getAttribute('data-date-label') || '',
      slot: root.getAttribute('data-slot') || ''
    };
    var errorBox = root.querySelector('[data-vc-error]');
    var express = root.querySelector('[data-vc-express]');
    var weekdayCodes = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
    var closedWeekdays = (root.getAttribute('data-closed-weekdays') || '').split(',').filter(Boolean);
    var closedDates = (root.getAttribute('data-closed-dates') || '').split(',').filter(Boolean);

    function currentMethod() {
      return methodField ? methodField.value : 'Afhalen';
    }

    function dateProblem(value) {
      if (!value) return 'Kies een dag waarop u uw bestelling komt afhalen.';
      if (dateInput && dateInput.min && value < dateInput.min) return 'Die dag kan niet meer. Kies een volgende dag.';
      var parts = value.split('-');
      var day = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])).getDay();
      if (closedWeekdays.indexOf(weekdayCodes[day]) !== -1 || closedDates.indexOf(value) !== -1) {
        return 'Het café is dan gesloten. Kies een andere dag.';
      }
      return '';
    }

    function pickupProblem() {
      if (currentMethod() !== 'Afhalen') return '';
      return dateProblem(state.date) || (state.slot ? '' : 'Kies een uur waarop u komt afhalen.');
    }

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = !message;
    }

    // Akkoord voorwaarden tankbier (alleen als het vakje op de pagina staat)
    var agreeBlock = root.querySelector('[data-vc-agree]');
    var agreeBox = root.querySelector('[data-vc-agree-box]');
    var agreeError = root.querySelector('[data-vc-agree-error]');
    var AGREE_KEY = 'Akkoord bruikleenvoorwaarden tankbier';

    function agreeProblem() {
      if (!agreeBox || agreeBox.checked) return '';
      return 'Vink aan dat u akkoord gaat met de voorwaarden voor de bruikleen van de biertank.';
    }

    function showAgreeError(message) {
      if (!agreeError) return;
      agreeError.textContent = message || '';
      agreeError.hidden = !message;
      if (agreeBlock) agreeBlock.classList.toggle('is-missing', !!message);
    }

    function stamp() {
      var d = new Date();
      function two(n) { return (n < 10 ? '0' : '') + n; }
      return 'Ja, ' + two(d.getDate()) + '/' + two(d.getMonth() + 1) + '/' + d.getFullYear() + ' ' + two(d.getHours()) + ':' + two(d.getMinutes());
    }

    if (agreeBox) {
      agreeBox.addEventListener('change', function () {
        var attributes = {};
        if (agreeBox.checked) {
          agreeBox.value = stamp();
          attributes[AGREE_KEY] = agreeBox.value;
          showAgreeError('');
        } else {
          attributes[AGREE_KEY] = '';
        }
        updateExpress();
        saveAttributes(attributes);
      });
    }

    // Tankbier niet meer in de mand: oud akkoord wissen
    if (root.querySelector('[data-vc-agree-stale]')) {
      var clear = {};
      clear[AGREE_KEY] = '';
      saveAttributes(clear);
    }

    function updateExpress() {
      if (express) express.hidden = !!(pickupProblem() || agreeProblem());
    }

    function nextSlot(slot) {
      var index = slotValues.indexOf(slot);
      if (index === -1) return '';
      if (index + 1 < slotValues.length) return slotValues[index + 1];
      var parts = slot.split(':');
      var hour = parseInt(parts[0], 10);
      if (isNaN(hour)) return '';
      return String(hour + 1).padStart(2, '0') + ':' + (parts[1] || '00');
    }

    function renderMoment() {
      if (!moment) return;
      var when = state.label || state.date;
      if (!when || !state.slot) {
        moment.textContent = 'Kies een dag en een uur';
        return;
      }
      var end = nextSlot(state.slot);
      moment.textContent = end
        ? when + ' tussen ' + state.slot + ' en ' + end
        : when + ' vanaf ' + state.slot;
    }

    function setDate(value, label) {
      var problem = dateProblem(value);
      if (problem) {
        if (dateInput) dateInput.value = state.date;
        showError(problem);
        return;
      }
      showError('');
      state.date = value;
      state.label = label || value;
      if (dateInput) dateInput.value = value;
      root.querySelectorAll('[data-vc-day]').forEach(function (day) {
        day.setAttribute('aria-pressed', day.getAttribute('data-value') === value ? 'true' : 'false');
      });
      if (dateButton) {
        var custom = !root.querySelector('[data-vc-day][data-value="' + value + '"]');
        dateButton.setAttribute('aria-pressed', custom ? 'true' : 'false');
        dateButton.querySelector('span').textContent = custom ? state.label : 'Kies datum';
      }
      renderMoment();
      updateExpress();
      saveAttributes({ Afhaaldatum: value });
    }

    root.querySelectorAll('[data-vc-day]').forEach(function (day) {
      day.addEventListener('click', function () {
        if (day.disabled) return;
        setDate(day.getAttribute('data-value'), day.getAttribute('data-label'));
      });
    });

    if (dateButton && dateInput) {
      dateButton.addEventListener('click', function () {
        if (typeof dateInput.showPicker === 'function') dateInput.showPicker();
        else dateInput.focus();
      });
    }

    if (dateInput) {
      dateInput.addEventListener('change', function () {
        var parts = dateInput.value.split('-');
        var label = parts.length === 3 ? parts[2] + '/' + parts[1] : dateInput.value;
        setDate(dateInput.value, label);
      });
    }

    slotButtons.forEach(function (slot) {
      slot.addEventListener('click', function () {
        slotButtons.forEach(function (other) { other.setAttribute('aria-pressed', 'false'); });
        slot.setAttribute('aria-pressed', 'true');
        state.slot = slot.getAttribute('data-value');
        var field = root.querySelector('[data-vc-slot-field]');
        if (field) field.value = state.slot;
        renderMoment();
        showError('');
        updateExpress();
        saveAttributes({ Afhaaluur: state.slot });
      });
    });

    renderMoment();
    updateExpress();

    var form = root.querySelector('form#cart');
    if (form) {
      form.addEventListener('submit', function (event) {
        var problem = pickupProblem();
        if (problem) {
          event.preventDefault();
          showError(problem);
          if (pickupBlock) pickupBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var firstDay = root.querySelector('[data-vc-day]:not([disabled])');
          if (firstDay) firstDay.focus({ preventScroll: true });
          return;
        }
        var agree = agreeProblem();
        if (agree) {
          event.preventDefault();
          showAgreeError(agree);
          if (agreeBlock) agreeBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
          agreeBox.focus({ preventScroll: true });
        }
      });
    }

    var note = root.querySelector('[data-vc-note]');
    if (note) {
      var timer = null;
      note.addEventListener('input', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          post('cart/update.js', { note: note.value }).catch(function () {});
        }, 600);
      });
    }

    root.querySelectorAll('[data-vc-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        post('cart/add.js', { items: [{ id: Number(button.getAttribute('data-vc-add')), quantity: 1 }] }).then(reload).catch(reload);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
